// Match the backend's ASCII dot-atom and single DNS label validation.
const LOCAL = /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*/;
const LABEL = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?/;
const matches = (pattern, value) => value.match(pattern)?.[0] === value;

export function mailboxInputError({customerMail, customerDomainName}, deskDomainName) {
    if (customerMail && (customerMail.length > 64 || !matches(LOCAL, customerMail))) return "invalid_user";
    if (customerDomainName && !matches(LABEL, customerDomainName)) return "invalid_domain";
    if (`${customerMail}@${customerDomainName}.${deskDomainName}`.length > 254) return "invalid_address";
    return null;
}
